import { ReactComponent as ElevationIcon } from '@assets/components/gauge/elevation.svg';
import { Box, Icon, Text, VStack } from '@chakra-ui/react';
import { formatDegree } from '@utils/sensors/camera/gauge.utils';

import { Coordinates } from '@/types/commons/commons.types';

import ElevationCompassBackground from './ElevationCompassBackground';
import ElevationCompassTargets from './ElevationCompassTargets';
import ElevationCompassValue from './ElevationCompassValue';

type Props = {
  fov: number;
  tilt: number;
  min: number;
  max: number;
  replayMode: boolean;
  cameraPosition: Coordinates;
  cameraAltitude: number;
};

export default function ElevationCompass({
  fov,
  tilt,
  replayMode,
  cameraPosition,
  min,
  max,
  cameraAltitude,
}: Readonly<Props>) {
  return (
    <Box marginLeft="-57px" width="296px" height="296px">
      <Box position="relative" width="100%" height="100%" clipPath="polygon(50% -20%, 150% -20%, 150% 120%, 50% 120%)">
        <ElevationCompassBackground min={min} max={max} />
        <ElevationCompassValue fov={fov} tilt={tilt} />
        <ElevationCompassTargets
          replayMode={replayMode}
          cameraPosition={cameraPosition}
          cameraAltitude={cameraAltitude}
        />
      </Box>
      <VStack gap={0.5} width="72px" position="absolute" top="-15px" left="30px" alignItems="start">
        <Icon as={ElevationIcon} width="32px" height="16px" />
        <Text backgroundColor="neutral.black" fontWeight="medium" padding={0.25}>
          {formatDegree(tilt)}
        </Text>
      </VStack>
    </Box>
  );
}
